//@flow
import FunctionStore from '../Base/functionStoreClass';
import { setFlag } from '../Base/storeUtils';
import Constants from '../../constants';

import type {HandlerAdd} from '../Base/functionStoreClass';

const _openModal = setFlag('open', true);
const _closeModal = setFlag('open', false);

export default class CreateAccountModalClass extends FunctionStore {
  isOpen() {
    return this._getFlag('open');
  }

  isExpanded() {
    return this._getFlag('expanded');
  }

  _setup(onSuccess:HandlerAdd, onError:HandlerAdd) {
    onSuccess(Constants.OPEN_CREATE_ACCOUNT_MODAL, _openModal);
    onSuccess(Constants.CLOSE_CREATE_ACCOUNT_MODAL, _closeModal);
    onSuccess(Constants.LOGIN, _closeModal);
    onSuccess(Constants.CREATE_CUSTOMER_SUCCESS, _closeModal);

    onSuccess(Constants.EXPAND_CREATE_ACCOUNT_MODAL, setFlag('expanded', true));
    onSuccess(Constants.COLLAPSE_CREATE_ACCOUNT_MODAL, setFlag('expanded', false));
  }
}
